// 複製文字用
import useToastStore from '@/store/useToastStore';

export default function useCopy() {
    const { openToast } = useToastStore();

    const copy = async (text: string) => {
        await navigator.clipboard.writeText(text);
        openToast('已複製');
    };
    return copy;
}
